import mitt from 'mitt';

export default function EventBus(app) {
    const vueApp = app.vueApp || app;
    vueApp.config.globalProperties.$bus = mitt();
}
